const AUD = new Intl.NumberFormat('en-AU', {
  style: 'currency',
  currency: 'AUD',
  maximumFractionDigits: 0,
});
const AUD_CENTS = new Intl.NumberFormat('en-AU', {
  style: 'currency',
  currency: 'AUD',
  maximumFractionDigits: 2,
});
const PCT = new Intl.NumberFormat('en-AU', {
  style: 'percent',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});
const NUM = new Intl.NumberFormat('en-AU');

export const money = (n) => (Number.isFinite(n) ? AUD.format(n) : '—');
export const moneyCents = (n) => (Number.isFinite(n) ? AUD_CENTS.format(n) : '—');
export const pct = (n) => (Number.isFinite(n) ? PCT.format(n) : '—');
export const num = (n) => (Number.isFinite(n) ? NUM.format(n) : '—');
